module.exports = __webpack_public_path__ + "img/tube-fixator.9a66b9b9.png";